export function parsePhoto({
  id,
  title,
  description,
  copyright,
  url,
  thumbnail,
  thumbnailSquare
}, backendUrl) {
  return {
    id,
    title,
    description,
    copyright,
    url: backendUrl ? `${backendUrl}${url}` : url,
    thumbnailUrl: backendUrl ? `${backendUrl}${thumbnail}` : thumbnail,
    squaredThumbnailUrl: backendUrl ? `${backendUrl}${thumbnailSquare}` : thumbnailSquare
  };
}